// TODO(APPLYME-6296): ids still to request on the Elcatech portal. Until they exist the texts render the '-' miss
// sentinel of `apmTranslate`; replace each use of this constant with its id.
const TODO_RESOURCE_ID: number | undefined = undefined;

/**
 * Content resource ids of the cross-selling texts. The loose accessory labels are the ones the backend uses in the
 * offer and order documents, so the views read as the documents do.
 */
export const CrossSellingResourceIds = {
  SECTION_TITLE: 520759, // "Accessori sfusi - non forniti a corredo della macchina"
  ACCESSORY_NAME: 520758,
  SOURCE_SIZE: 520760,
  LOOSE_ACCESSORIES_SUBTOTAL: 520761,
  UNITS_SUBTOTAL: 520763,
  MIN_QUANTITY_NOT_MET: 520757, // #1 the minimum, #2 the accessory code: the 422 of the backend
  SUITABLE_ACCESSORIES: TODO_RESOURCE_ID, // "#1 ACCESSORIES SUITABLE FOR THIS UNIT": link under a unit, panel title
  MIN_QUANTITY: TODO_RESOURCE_ID, // "Min Qty"
  QUANTITY_IN_SELECTION: TODO_RESOURCE_ID, // "Qty in quote"
  CROSS_SELLING: TODO_RESOURCE_ID, // tooltip of the cross-selling icon (model page, catalog)
} as const;
